import Vue from 'vue'
import { Context } from '@nuxt/types/app'

import {
  DEFAULT_LANG,
  DEFAULT_FONT,
  SQUARE_FONT,
  SPECIAL_FONT,
  DEFAULT_FONT_MAP,
  deepStyle,
  Queue,
  D_FONT,
  H_FONT,
  propSet,
  FONT_WEIGHT_RULE
} from './helper'

import { isIOS } from '@/utils/getDevice'

class FontTransform {
  // 各语言json包
  langs = {}
  // 初始字体、字号转换队列
  familyAndSizeQueue = null
  // 字体转换后 字重、vw转换队列
  weightQueue = null
  vwQueue = null

  fontWeightRule = FONT_WEIGHT_RULE
  store: any

  constructor(store: any) {
    this.store = store
  }

  get ACTIVE_LANG() {
    return (this.store as any).state.LANG
  }

  get isSameLang() {
    return DEFAULT_LANG === this.ACTIVE_LANG
  }

  // @ts-ignore
  run(langs) {
    this.langs = langs
    // @ts-ignore
    this.familyAndSizeQueue = new Queue()
    // @ts-ignore
    this.weightQueue = new Queue()
    // @ts-ignore
    this.vwQueue = new Queue()

    // 同步当前语言样式并转化字体
    // @ts-ignore
    deepStyle(this.langs[DEFAULT_LANG], this.eachStyle.bind(this))
    // @ts-ignore
    this.familyAndSizeQueue.consume()
    // 第二轮转换vw及字重(字重和字体有关，所以放在第二轮)
    deepStyle(
      // @ts-ignore
      this.langs[this.ACTIVE_LANG],
      this.eachStyleForWeightVw.bind(this)
    )
    // @ts-ignore
    this.weightQueue.consume()
    // @ts-ignore
    this.vwQueue.consume()
  }

  // @ts-ignore
  eachStyle(style, path) {
    const map = path.slice(1).split('.')
    Object.keys(style).forEach((key) => {
      if (key === 'font-family') {
        this.fontFamily(style, map)
      }
    })
  }

  // @ts-ignore
  eachStyleForWeightVw(style, path) {
    const map = path.slice(1).split('.')
    Object.keys(style).forEach((key) => {
      if (key === 'font-weight') {
        // @ts-ignore
        this.fontWeight(style, map)
      }
    })
    if (!style['font-weight']) {
      // @ts-ignore
      this.fontWeight(style, map)
    }
  }

  // @ts-ignore
  fontFamily(style, map) {
    const fontFamily = style['font-family']
    const fontType = style['font-type'] || 'T'
    const finallyPath = [...map, 'font-family']

    // 如果是苹方字体则按设计规则进行语言字体转换
    if (fontFamily.includes(DEFAULT_FONT.square.IOS)) {
      // @ts-ignore
      const fontTypeMap = { T: DEFAULT_FONT, D: D_FONT, H: H_FONT }[fontType]
      const familyType = SQUARE_FONT.includes(this.ACTIVE_LANG)
        ? 'square'
        : 'letter'
      const device = isIOS ? 'IOS' : 'android'
      // TODO
      // const device = 'IOS'
      // @ts-ignore
      this.familyAndSizeQueue.enqueue(() =>
        propSet(
          // @ts-ignore
          this.langs[this.ACTIVE_LANG],
          finallyPath,
          fontTypeMap[familyType][device],
          this.ACTIVE_LANG
        )
      )
      return
    }

    // 如果不是苹方字体 则直接同步到当前语言
    // @ts-ignore
    this.familyAndSizeQueue.enqueue(() =>
      // @ts-ignore
      propSet(
        this.langs[this.ACTIVE_LANG],
        finallyPath,
        fontFamily,
        this.ACTIVE_LANG
      )
    )
  }

  // 由于涉及到字体转换，字重映射再下个周期deep处理
  // @ts-ignore
  fontWeight(style) {
    const fontFamily = style['font-family'] || ''
    const fontWeight = style['font-weight'] || 400 // 没有就是normal
    const target = [
      DEFAULT_FONT_MAP.some((item) => fontFamily.includes(item)) && 'T',
      fontFamily === SPECIAL_FONT[0] && 'D',
      fontFamily === SPECIAL_FONT[1] && 'H'
    ]
    const type = target.filter((item) => item)
    // 如果命中字体走设计规则映射
    if (type[0]) {
      // @ts-ignore
      this.weightQueue.enqueue(() =>
        propSet(
          style,
          'font-weight',
          // @ts-ignore
          this.fontWeightRule[type[0]][fontWeight] || fontWeight,
          this.ACTIVE_LANG
        )
      )
    } else {
      // @ts-ignore
      this.weightQueue.enqueue(() =>
        propSet(style, 'font-weight', fontWeight, this.ACTIVE_LANG)
      )
    }
  }
}

export default ({ store } = <Context>{}) => {
  if (Vue.prototype.$fontTransform) {
    return
  }

  const fontTransform = new FontTransform(store)
  Vue.use({
    install: (Vue) => {
      Object.defineProperty(Vue.prototype, '$fontTransform', {
        get() {
          return fontTransform
        }
      })
    }
  })
}
